import { Contract, ethers } from "ethers";

const WITHDRAW = require("./Withdarw.json");

export async function getTotalPartners(contractAddress, signer) {
    const contract = new Contract(contractAddress, WITHDRAW.abi, signer);

    const total = await contract.total_partners();

    return +total;
}

export async function getPartnerWallet(contractAddress, signer, partnerIndex) {
    const contract = new Contract(contractAddress, WITHDRAW.abi, signer);

    const address = await contract.partners(partnerIndex);

    return address;
}

export async function getPartnerShare(contractAddress, signer, wallet) {
    const contract = new Contract(contractAddress, WITHDRAW.abi, signer);

    const share = await contract.partners_shares(wallet);

    return +share
}

export async function claimIncome(contractAddress, signer, lpTokenAddress) {
    const contract = new Contract(contractAddress, WITHDRAW.abi, signer);

    await contract.claim_income(lpTokenAddress);
}